<template>
  <div class="container">
    <img class="service-icon" :src="props.icon" alt="An SVG image giving context to the service provided by JAW Innovation Group">
    <h5 class="service-title"> {{ props.title }} </h5>
    <p class="service-text"> {{ props.text }} </p>
  </div>
</template>

<script setup>

const props = defineProps({
  icon: String,
  title: String,
  text: String
})

</script>

<style scoped>

.container {
  width: 271px;
  height: 279px;
  background-color: #070923;
  margin-bottom: 30px;
}

.service-icon {
  margin-top: 25px;
  margin-bottom: 15px;
}

.service-title {
  width: 216px;
  font-size: 18px;
  color: #00FFBA;
  line-height: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
}

.service-text {
  text-align: center;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 12px;
  line-height: 20px;
}


@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .container {
    width: 425px;
    height: 475px;
  }

  .service-icon {
    margin-top: 25px;
    margin-bottom: 25px;
    width: 100px;
    height: 100px;
  }

  .service-title {
    width: 400px;
    font-size: 32px;
    color: #00FFBA;
    line-height: 50px;
    margin: 0 auto;
    margin-bottom: 35px;
  }

  .service-text {
    text-align: center;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 20px;
    line-height: 32px;
  }
}

/* xl: ≥ 1280px - Desktops */
@media (min-width: 1280px) {

}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .container {
    width: 500px;
    height: 545px;
  }

  .service-icon {
    margin-top: 25px;
    margin-bottom: 15px;
    width: 100px;
    height: 100px;
  }

  .service-title {
    width: 449px;
    height: 100px;
    margin: 0 auto;
    margin-bottom: 40px;
    color: #00FFBA;
    font-size: 35px;
    line-height: 50px;
  }

  .service-text {
    text-align: center;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 24px;
    line-height: 35px;
  }
}
</style>